import React from 'react';
import Icon from '~/core/scripts/components/Icon';

const TeaserLink = React.memo(function(props) {
  
  return (
    <div className="iframeteaser__sub teaserlink">
      <div className="iframeteaser__sub-title">
        Alle Delikte, Alle Regionen
      </div>
      <div className="iframeteaser__sub-cta">
        zum Kriminalitätsatlas für NRW <Icon type="arrow-left"/>
      </div>
    </div>
  );
});

export default TeaserLink;

